import { FETCH_STATISTICS } from '@/store/statistics'

const getAllStatistics = (fetchAllStatistics) => async (dispatch) => {
  dispatch(FETCH_STATISTICS(fetchAllStatistics))
}

export { getAllStatistics }
